<template>
  <div>
    <v-tabs
      v-if="filters.length"
      v-model="activeFilter"
      class="history-filters mb-4"
      style="
        border-bottom: thin solid
          rgba(var(--v-border-color), var(--v-border-opacity));
      "
      color="primary"
      density="compact"
      slider-color="blue-darken-3">
      <v-tab
        v-for="filter in filters"
        :key="filter.value"
        :value="filter.value"
        class="text-none">
        <span class="font-weight-bold">{{ filter.title }}</span>
        <span class="text-disabled ml-1">
          {{ getFilterCount(filter.value) }}
        </span>
      </v-tab>
    </v-tabs>

    <v-table density="comfortable">
      <tbody>
        <template v-for="group in groupedHistory" :key="group.date">
          <tr>
            <td colspan="3">
              <span class="text-disabled font-weight-bold">
                {{ new CustomDate(group.date).toString() }}
              </span>
            </td>
          </tr>

          <tr v-for="item in group.items" :key="item.id">
            <td class="text-disabled" style="width: 170px; white-space: nowrap">
              {{ item.date.substring(11, 16) }}
            </td>
            <td style="width: 120px">
              <v-chip
                :color="item.color"
                class="font-weight-bold"
                density="compact"
                size="x-small"
                variant="tonal">
                <span>{{ item.type }}</span>
              </v-chip>
            </td>
            <td>
              <div class="d-flex align-center ga-2 flex-wrap">
                <span class="font-weight-bold">{{ item.user }}</span>
                <span class="text-disabled">{{ item.position }}</span>
              </div>
              <template v-if="item.fields?.length">
                <div
                  v-for="field in item.fields"
                  :key="field.label"
                  class="d-flex ga-4 py-1">
                  <span class="text-disabled" style="min-width: 160px">{{
                    field.label
                  }}</span>
                  <span>→ {{ field.value }}</span>
                </div>
              </template>
              <template v-else>
                <div v-if="item.description">{{ item.description }}</div>
                <div
                  v-if="item.statusTo"
                  class="text-disabled text-caption mt-1">
                  Стан
                  <span v-if="item.statusFrom"> {{ item.statusFrom }} →</span>
                  <span class="font-weight-medium text-medium-emphasis">
                    {{ item.statusTo }}</span
                  >
                </div>
                <div
                  v-if="item.comment"
                  class="text-disabled text-caption mt-1">
                  Коментар: {{ item.comment }}
                </div>
              </template>
            </td>
          </tr>
        </template>
      </tbody>
    </v-table>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { CustomDate } from 'best-modules/utils'
import { HistoryTimelineFilter, HistoryTimelineItem } from './types'

defineOptions({
  name: 'HistoryTimeline',
})

const props = withDefaults(
  defineProps<{
    items: HistoryTimelineItem[]
    filters?: HistoryTimelineFilter[]
  }>(),
  {
    filters: () => [],
  }
)

const activeFilter = ref<string>('all')

const filteredItems = computed<HistoryTimelineItem[]>(() => {
  if (!props.filters.length || activeFilter.value === 'all') {
    return props.items
  }
  return props.items.filter(item => item.category === activeFilter.value)
})

const groupedHistory = computed<
  { date: string; items: HistoryTimelineItem[] }[]
>(() =>
  filteredItems.value.reduce<{ date: string; items: HistoryTimelineItem[] }[]>(
    (groups, item) => {
      const date = item.date.split(' ')[0]
      const group = groups.find(g => g.date === date)
      if (group) {
        group.items.push(item)
      } else {
        groups.push({ date, items: [item] })
      }
      return groups
    },
    []
  )
)

const getFilterCount = (filter: string): number => {
  if (filter === 'all') return props.items.length
  return props.items.filter(item => item.category === filter).length
}
</script>
